import type { ProjectType } from '../packages/api-client/pm-api';

// Missing type is a legacy server response; existing projects used software tools.
export function isSoftwareProject(project: { project_type?: ProjectType }): boolean {
  return project.project_type !== 'general';
}

